module.exports = __webpack_public_path__ + "static/media/1-dreaming.c23245dd.jpg";